/*=========================================================================================
  File Name: moduleAssessmentQuestionActions.js
  Description: AssessmentQuestion Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/CustomerReview/AddCustomerReview", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/CustomerReview/GetAllCustomerReview?type="+2)
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getCourseReviewByCode({ commit },data) {
    return new Promise((resolve, reject) => {
      axios.get("api/CustomerReview/GetCourseReviewByCode?code="+data.Code+"&AssessmentTypeID="+data.AssessmentTypeID)
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getGeneralPractical(context,data) {
    return new Promise((resolve, reject) => {
      debugger
      if(data.Type==1){
        axios.get("api/Trainee/getGeneralPractical?courseClassID="+data.CourseClassID+"&traineeID="+data.TraineeID)
        .then((response) => {

         // commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      }
      else{
        axios.get("api/Trainee/getCoursePractical?courseClassID="+data.CourseClassID+"&traineeID="+data.TraineeID)
        .then((response) => {

         // commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      }

    })
  },
  getTraineeAvailableReviews({ commit }) {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/CustomerReview/GetTraineeAvailableReviews")
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getInstructorAvailableReviews({ commit },period) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("api/InstractorFeedBack/GetInstructorCourseClass",period)
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getInstructorQuestions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/InstractorFeedBack/GetAllInstractorQuestion")
        .then((response) => {

          //commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  submitInsturctorFeedBackAnswer({ commit },obj) {
    return new Promise((resolve, reject) => {
      axios.post("api/InstractorFeedBack/submitInsturctorFeedBackAnswer",obj)
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetInstractorFeedbackAnswer({ commit },AnswerId) {
    return new Promise((resolve, reject) => {
      axios.get("api/InstractorFeedBack/GetInstractorFeedbackAnswer?FeedBackAnswerId="+AnswerId)
        .then((response) => {

          //commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllInstructorFeedback({ commit }) {
    debugger
    return new Promise((resolve, reject) => {
      axios.get("api/InstractorFeedBack/GetAllInstractorFeedback")
        .then((response) => {

          commit('SET_CourseReviews', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem( context,item) {
    return new Promise((resolve, reject) => {
      axios.put("api/CustomerReview/UpdateCustomerReview?ID="+item.ID, item)
        .then((response) => {
         // commit('UPDATE_CourseReview', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetItemByID({ commit }, itemid) {
    return new Promise((resolve, reject) => {
      axios.get("api/CustomerReview/GetCustomerReview?CustomerReviewID="+ itemid)
        .then((response) => {
          commit('UPDATE_CourseReview', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CustomerReview/DeleteCustomerReview?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeQuestion({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/CustomerReview/DeleteCutomerReviewQuestion?ID="+item.ID)
        .then((response) => {
         // commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeAnswer(context, ID) {
    return new Promise((resolve, reject) => {
      axios.delete("api/AssessmentQuestion/DeleteAssessmentAnswer?ID="+ID)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
   },
  // getQuestionByFilter({ commit }, item){
  //
  //   return new Promise((resolve, reject) => {
  //     axios.post("api/AssessmentQuestion/getQuestionByFilter",item)
  //       .then((response) => {
  //         commit('SET_QuestionByFilter', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  getQuestionWithResultAnswerByFilter({ commit }, item){

    return new Promise((resolve, reject) => {
      axios.post("api/CustomerReview/getQuestionWithResultAnswerByFilter",item)
        .then((response) => {
          commit('SET_QuestionByFilter', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getNumberOfTrainee(context,data){

    return new Promise((resolve, reject) => {
      axios.post("api/CustomerReview/getNumberOfTrainee",data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

}
